import React, { useEffect, useRef, useState } from 'react';

const HEX_SIZE = 100; // Radio del hexágono
const HEX_SEPARATION_H = 28; // Separación horizontal (más grande)
const HEX_SEPARATION_V = -16;  // Separación vertical aún más negativa
const EFFECTIVE_SIZE = HEX_SIZE - Math.max(HEX_SEPARATION_H, HEX_SEPARATION_V) / 2;

// Colores en escala de grises claros
const HEX_COLOR = '#f5f5f5';
const BORDER_COLOR = '#e3e1e1';
const BG_COLOR = BORDER_COLOR;
const SHADOW = 'rgba(200,200,200,0.10)';

function getHexPoints(cx: number, cy: number, size: number) {
  const points = [];
  for (let i = 0; i < 6; i++) {
    const angle = Math.PI / 3 * i + Math.PI / 6;
    points.push([
      cx + size * Math.cos(angle),
      cy + size * Math.sin(angle)
    ]);
  }
  return points.map(p => p.join(',')).join(' ');
}

export const HoneycombBackground: React.FC = () => {
  const svgRef = useRef<SVGSVGElement>(null);
  const [dimensions, setDimensions] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const svg = svgRef.current;
      if (!svg) return;
      const hexes = svg.querySelectorAll('.honey-hex');
      hexes.forEach(hex => hex.classList.remove('glow'));
      // Ilumina aleatoriamente 7 hexágonos
      for (let i = 0; i < 7; i++) {
        const idx = Math.floor(Math.random() * hexes.length);
        hexes[idx].classList.add('glow');
      }
    }, 1800);
    return () => clearInterval(interval);
  }, [dimensions]);

  // Separación personalizada en ambos ejes
  const horizSpacing = 1.5 * EFFECTIVE_SIZE + HEX_SEPARATION_H;
  const vertSpacing = Math.sqrt(3) * EFFECTIVE_SIZE + HEX_SEPARATION_V;

  const svgWidth = dimensions.width;
  const svgHeight = dimensions.height;
  const cols = Math.ceil(svgWidth / horizSpacing) + 2;
  const rows = Math.ceil(svgHeight / vertSpacing) + 2;

  const hexes = [];
  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      const x = col * horizSpacing + (row % 2 ? horizSpacing / 2 : 0);
      const y = row * vertSpacing;
      hexes.push(
        <polygon
          key={`${row}-${col}`}
          className="honey-hex transition-all duration-300 ease-in-out"
          points={getHexPoints(x, y, EFFECTIVE_SIZE)}
          fill={HEX_COLOR}
          stroke={BORDER_COLOR}
          strokeWidth={2}
          filter="url(#shadow)"
        />
      );
    }
  }

  return (
    <svg
      ref={svgRef}
      className="fixed top-0 left-0 z-0 w-screen h-screen pointer-events-none"
      width="100vw"
      height="100vh"
      viewBox={`0 0 ${svgWidth} ${svgHeight}`}
      preserveAspectRatio="xMidYMid slice"
      style={{ background: BG_COLOR }}
      aria-hidden="true"
    >
      <rect x="0" y="0" width="100%" height="100%" fill={BG_COLOR} />
      <defs>
        <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="4" stdDeviation="4" floodColor={SHADOW} />
        </filter>
      </defs>
      {hexes}
    </svg>
  );
}; 